import { render } from "./ElectronicNoticePage.vue?vue&type=template&id=b8aa7376"
import script from "./ElectronicNoticePage.vue?vue&type=script&lang=js"
export * from "./ElectronicNoticePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__